// extracted by mini-css-extract-plugin
export var blockHeader = "le-pilote-next-trips-search-block-module--blockHeader--1bc6b";
export var blockPicto = "le-pilote-next-trips-search-block-module--blockPicto--b4711";
export var field = "le-pilote-next-trips-search-block-module--field--09d50";
export var form = "le-pilote-next-trips-search-block-module--form--f7c51";
export var formPart = "le-pilote-next-trips-search-block-module--formPart--c341b";
export var searchButton = "le-pilote-next-trips-search-block-module--searchButton--1f6f6";
export var title = "le-pilote-next-trips-search-block-module--title--9a454";